export default __webpack_public_path__ + "static/media/twitter-icon-black.e3196a57.svg";